import FetchUtils from '../utils/fetch.utils';
import CaasStorageKeys from '../constants/caas.storage.keys';

export default class CreditService {
  static BASE_URL = `${process.env.PREACT_APP_API_DOMAIN_CREDITS}/api/onboarding`;
  static TAKE_CREDIT = `${process.env.PREACT_APP_API_DOMAIN_CREDITS}/api/credits`;
  static PAY_CREDIT = `${process.env.PREACT_APP_API_DOMAIN_CREDITS}/api/credits/payment`;
  static CREDIT_FORM = `${process.env.PREACT_APP_API_DOMAIN_CREDITS}/api/products/onboarding/form`;

  static getData = async () => {
    return FetchUtils.get(`${CreditService.BASE_URL}/form`);
  };

  static getCreditConfig = async organizationCode => {
    const url =
      `${CreditService.CREDIT_FORM}/options` +
      FetchUtils.getQueryParams({
        organization: organizationCode,
        product_type: 'CREDIT_LINE',
      });
    return FetchUtils.get(url);
  };

  static saveCreditOnboardingForm = async (
    organizationCode,
    productId,
    data,
  ) => {
    const {
      city,
      district,
      street,
      buildingNumber,
      floorAndFlatNumber,
      residentialStatus,
      employmentStatus,
      sectorName,
      jobTitle,
      jobAntiquity,
      employerName,
      workCity,
      workDistrict,
      monthlyIncomeAmount,
      maritalStatus,
      familyDependentsCount,
      requestedCreditLimit,
    } = data;

    const body = {
      productId: productId,
      form: {
        organizationCode: organizationCode,
        productType: 'CREDIT_LINE',
        answers: {
          personal: {
            address: {
              city: city.value,
              district: district.value,
              street: street.value,
              reference: buildingNumber.value,
              floor: floorAndFlatNumber.value,
              residentialStatus: residentialStatus.value,
            },
            family: {
              marital: {
                status: maritalStatus.value,
              },
              dependents: familyDependentsCount.value,
            },
          },
          job: {
            status: employmentStatus.value,
            antiquity: jobAntiquity.value,
            employer: {
              name: employerName.value,
            },
            sector: {
              name: sectorName.value,
            },
            title: jobTitle.value,
            address: {
              city: workCity.value,
              district: workDistrict.value,
            },
            income: {
              amount: Number(monthlyIncomeAmount.value) ?? 0,
            },
          },
          credit: {
            amount: Number(requestedCreditLimit.value) ?? 0,
          },
        },
      },
    };

    return FetchUtils.post(CreditService.CREDIT_FORM, body, {
      headers: {
        'X-Device-Model':
          window.__CAAS__.config[CaasStorageKeys.DEVICE].model ?? '',
        'X-Device-Carrier':
          window.__CAAS__.config[CaasStorageKeys.DEVICE].carrier ?? '',
      },
    });
  };

  static takeCredit = async (
    idempotencyKey,
    amount,
    organizationCode,
    installments,
    type,
  ) => {
    const body = {
      amount: amount,
      organizationCode: organizationCode,
      installments: installments,
      type: type.toUpperCase(),
    };

    return FetchUtils.post(CreditService.TAKE_CREDIT, body, {
      headers: { 'x-idempotency-key': idempotencyKey },
    });
  };

  static payCredit = async (idempotencyKey, amount, organizationCode) => {
    const body = {
      organizationCode: organizationCode,
      amount: amount,
    };

    return FetchUtils.post(CreditService.PAY_CREDIT, body, {
      headers: { 'x-idempotency-key': idempotencyKey },
    });
  };
}
